import React, { Fragment } from 'react'
import { CenarioTable } from './CenarioTable'
import { CenarioFilter } from './CenarioFilter'

export const CenarioList = ({ classes, ...props }) => {
  return (
    <Fragment>
      <CenarioFilter />
      <CenarioTable classes={classes} props={props} />
    </Fragment>
  )
}
